import React from "react";
import "./Intro.css";
import Nav from "../Nav";
import { Link,withRouter} from "react-router-dom";

class Intro extends React.Component {
    render() {
        return (
            <div>
                <Nav/>
                <div className="row jumbotron">
          <div className="col-4 jumbotron" style={{height: '150vh'}}>
            <div className="container">
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Project">01 Master Plan</a></p>
              <p className="ab">Planning Structure</p>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/PlanningFeatures">Planning Features</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Intro"> 02 Project Introduction</a></p>
              <hr style={{backgroundColor: 'black',width: '100%' }}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/ProLoc">03 Project Location</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
            </div>
          </div>
        <div className="col-8">
        <div class="abhead4">
        <p></p>
        </div>
        <div class="jumbotron">
          <p style={{margin: 0, fontWeight: 'bold', fontSize: '30px'}}>Project Introduction</p>
          <hr style={{margin: 0, backgroundColor: 'green'}} className="w-100"/>
          <p style={{ fontWeight: 'bold'}}>Bamboo Ecological Commercial, Industrial & Tourism City</p>
        <p className="text-justify">Demand for Affordable Eco-Housing Units, Construction Materials, Water and Renewable Energy-related goods and services in Ghana, Sub-Saharan Africa and throughout the developing world is high and continues to expand. Bamboo Ecological Ecological Commercial, Industrial & Tourism City (GOOD MORNING BAMBOO) is being developed to capture the full environmental, social and economic value from such demand — localizing value creation through dedicated commercial, industrial and tourism development, as part of Government of Ghana’s 10-Point industrial agenda.<br/><br/>GOOD MORNING BAMBOO will become a 21st century ecosystem for the Affordable Eco-Housing Units, Construction Materials, Sustainable Water& Waste and Renewable Energy-related goods and services, a vibrant international commercial, industrial and tourism community built on excellence and innovation, and at its heart an excellent world-class workforce. It is also expected to contribute more than $100 million to the Ghana’s GDP and create up to 7,500 direct and indirect jobs at the maturity stage.<br/><br/>GOOD MORNING BAMBOO is attracting commercial, industrial and tourism investors across five strategic sectors: Affordable Eco-Housing, Construction Materials, Sustainable Water & Waste and Renewable Energy. From their GOOD MORNING BAMBOO -based facilities, investors in these sector-related supply chains will fill the massive gap for locally produced goods and gain a lasting competitive advantage.<br/><br/>GOOD MORNING BAMBOO will also cultivate and nurture disruptive innovation small and medium-sized enterprises, and stimulate innovation and entrepreneurship in the Affordable Eco-Housing, Construction Material, Sustainable Water & Waste and Renewable energy sector, significantly contributing to a more diversified environmental, social and economic landscape.<br/><br/>Also under development is a regional Logistics Zone connecting GOOD MORNING BAMBOO to the rest of Ghana and to neighboring countries through the Road Network and future Ghana Railway Network. Access to the Logistics Zone will drive efficiency and enhance competitiveness for GOOD MORNING BAMBOO tenants, as they address the needs of multiple markets from a single regional investment.
GOOD MORNING BAMBOO also offers opportunities for nonindustrial investors. Investment opportunities include residential, commercial real estate and tourism, as well as logistics facilities and services, prebuilt factories, warehouses, and Training facilities.



</p>
<div className="row ip">
              <div className="col-6">
            <div class="d-flex flex-row">
            <div class="p-4 align-self-start">
              <i class="fa fa-check"></i>
            </div>
            <div class="p-4 align-self-end">
              <p style={{fontWeight: 'bold', fontSize: '24px'}}>Residential facilities - 2,500 housing units (10,000 residents) - a 120-acre.</p>
            </div>
            </div>
            </div>
            <div className="col-6">
            <div class="d-flex flex-row">
            <div class="p-4 align-self-start">
              <i class="fa fa-check"></i>
            </div>
            <div class="p-4 align-self-end">
              <p style={{fontWeight: 'bold', fontSize: '24px'}}>Commercial facilities - a 15-acre central business enclave.</p>
            </div>
            </div>
            </div>
            </div>
            <div className="row ip">
              <div className="col-6">
            <div class="d-flex flex-row">
            <div class="p-4 align-self-start">
              <i class="fa fa-check"></i>
            </div>
            <div class="p-4 align-self-end">
              <p style={{fontWeight: 'bold', fontSize: '24px'}}>Public parks, tourism parks, children’s parks and gardens - over 40 acres of public parks, tourism parks, children’s parks, gardens & zoo.</p>
            </div>
            </div>
            </div>
            <div className="col-6">
            <div class="d-flex flex-row">
            <div class="p-4 align-self-start">
              <i class="fa fa-check"></i>
            </div>
            <div class="p-4 align-self-end">
              <p style={{fontWeight: 'bold', fontSize: '24px'}}>Industrial park - a 25-acre industrial park.</p>
            </div>
            </div>
            </div>
            </div>
        </div>
       
      
     </div>
   </div>
            </div>
        )
    }
}
export default withRouter(Intro);